var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.emitUrl
        ? _c(
            "el-upload",
            {
              staticClass: "avatar-uploader",
              attrs: {
                action: "" + _vm.baseURL + _vm.action,
                "before-upload": _vm.beforeUpload,
                "on-remove": _vm.handleRemove,
                "on-success": _vm.handleSuccess,
                data: _vm.upObj,
                "show-file-list": false,
                name: "file",
                multiple: _vm.multiple,
              },
            },
            [
              _vm.uploadText
                ? [
                    _c("el-button", { attrs: { type: "primary" } }, [
                      _vm._v(_vm._s(_vm.uploadText)),
                      _c("i", { staticClass: "el-icon-upload el-icon--right" }),
                    ]),
                  ]
                : [
                    _vm.raw
                      ? _c("el-avatar", {
                          staticClass: "abs el-avatar_up",
                          attrs: {
                            shape: "square",
                            fit: "cover",
                            src: _vm.rawUrl,
                          },
                        })
                      : _c("el-avatar", {
                          staticClass: "abs el-avatar_up",
                          attrs: {
                            shape: "square",
                            fit: "cover",
                            src: _vm.value,
                          },
                        }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "rel el-icon-plus avatar-uploader-icon",
                    }),
                  ],
            ],
            2
          )
        : _c(
            "el-upload",
            {
              attrs: {
                action: "" + _vm.baseURL + _vm.action,
                "list-type": "picture-card",
                "before-upload": _vm.beforeUpload,
                "on-preview": _vm.handlePictureCardPreview,
                "on-remove": _vm.handleRemove,
                "on-success": _vm.handleSuccess,
                data: _vm.upObj,
                "file-list": _vm.value,
                name: "file",
                limit: _vm.limit,
                multiple: _vm.multiple,
                "on-exceed": _vm.exceed,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.ratio
        ? _c("div", { staticClass: "el-upload__tip" }, [
            _vm._v("尺寸比例：" + _vm._s(_vm.ratio)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }